const SCAN_COMMAND_PKG = {
    navTitle: "Scans",
    routerName: "ScansDocs",
    commandsDescription: "Candle Pattern, Low Float, etc...",

    commandList: [
        {
            title: "Surge",
            routerRef: "surge",
            commandString: "!surge <Type>",
            description: "Scan of movers (surge) in the market 15m delayed- on 5m,10m,15m timeframe \n" +
                "The delayed data is 15 minutes delayed and \n" +
                "starts coming in at 10.01am for that trading day",
            parameters: [
                { name: "Type: ", desc: "up or down - to filter on moves" },
            ],
            examples: [
                "!surge",
                "!surge up",
                "!surge down",
            ],
            type: "Scans",
            shortcuts: ["none"]
        },
        {
            title: "Candle Pattern Scan",
            routerRef: "candle",
            commandString: "!candle <Pattern>",
            description: "Previus day scan of eod candlestick patterns \n" +
                "Bullish Engulfing - BE, Bullish Harami - BH, Inverted Hammer - IH \n" +
                "Hammer - H, Doji - D, Morning Star - MS, Bullish Doji - BD \n" +
                "Bearish Engulfing - BearE, Bearish Doji - BearD, Shooting Star - SS, Bearish",
            parameters: [
                { name: "Pattern: ", desc: "The symbol of the pattern" },
            ],
            examples: [
                "!candle H",
                "!candle SS"
            ],
            type: "Scans", 
            shortcuts: ["none"]
        },
        {
            title: "Popular - OFB  - 1 day or 1 hour",
            routerRef: "pop",
            commandString: "!pop1d",
            description: "Popular stocks on OFB over the last day - can also do !pop1h",
            parameters: ["none"],
            examples: [
                "!pop1d",
                "!pop1h"
            ],
            type: "Scans",
            shortcuts: ["none"]
        },
        {
            title: "r/WallStreeBets Popular",
            routerRef: "wsb",
            commandString: "!wsb",
            description: "Popular stocks on WSB over the last day",
            parameters: ["none"],
            examples: [
                "!wsb",
            ],
            type: "Scans",
            shortcuts: ["none"]
        },
        {
            title: "Top Short Volume",
            routerRef: "topshortvol",
            commandString: "!topshortvol",
            description: "Top short volume as reported by Finra",
            parameters: ["none"],
            examples: [
                "!topshortvol",
            ],
            type: "Scans",
            shortcuts: ["none"]
        },
        {
            title: "Screener",
            routerRef: "screener",
            commandString: "!screener <Pattern>",
            description: "Previus day scan of eod stock prices \n" +
                "breakout - Breakout Stock \n" +
                "gapup - Gap Ups \n" +
                "pennyactive  - Active Penny Stocks",
            parameters: [
                { name: "Pattern: ", desc: "The symbol of the pattern" },
            ],
            examples: [
                "!screener breakout",
                "!screener gapup"
            ],
            type: "Screener",
            shortcuts: ["none"]
        },
        {
            title: "MA Scans",
            routerRef: "scanner",
            commandString: "!scanner <Pattern>",
            description: "Previus day scan of top 20 by volume - Price action and MA Crosses \n" +
                "Price Crossed Above MA (200) - a200, Price Crossed Below MA (200) - b200 \n" +
                "Golden Cross (50 MA Crossed Above MA (200)) - GC, Death Cross (50 MA Crossed Below MA (200)) - DC",
            parameters: [
                { name: "Pattern: ", desc: "The symbol of the MA Scan" },
            ],
            examples: [
                "!scanner a200",
                "!scanner GC"
            ],
            type: "Scans", 
            shortcuts: ["none"]
        },
        {
            title: "Low Float",
            routerRef: "lowfloat",
            commandString: "!lowfloat <sector>",
            description: "find top 15 low float stocks of a sector \n" +
                "some possible are - software,manufacturing,biotechnology, computer, banks, insurance, \n" +
                "oil, electronic, personal, transportation",
            parameters: [
                { name: "Sector: ", desc: "The sector of the scan" },
            ],
            examples: [
                "!lowfloat software",
                "!lowfloat biotechnology"
            ],
            type: "Scans", 
            shortcuts: ["none"]
        },
        {
            title: "Upcoming Owners Meeting",
            routerRef: "sec14a",
            commandString: "!sec14a",
            description: "Stocks that have an upcoming owners meeting",
            parameters: ["none"],
            examples: [
                "!sec14a"
            ],
            type: "Scans", 
            shortcuts: ["none"]
        },
    ]
}

// eslint-disable-next-line no-unused-vars


export {SCAN_COMMAND_PKG};